import { useEffect, useState } from "react";

interface Slide {
  image: string;
  title: string;
  description: string;
}

interface SlideshowProps {
  slides: Slide[];
  interval?: number;
}

const Slideshow: React.FC<SlideshowProps> = ({ slides, interval = 4000 }) => {
  const [current, setCurrent] = useState(0);

  useEffect(() => {
    const autoplay = setInterval(() => {
      setCurrent((prev) => (prev + 1) % slides.length);
    }, interval);
    return () => clearInterval(autoplay);
  }, [slides, interval]);

  return (
    <div className="relative w-full h-full overflow-hidden rounded-xl">
      {/* Slide Image */}
      <img
        src={slides[current].image}
        alt={slides[current].title}
        className="w-full h-full object-cover transition-all duration-700"
      />

      {/* Overlay Text */}
      <div className="absolute bottom-0 w-full bg-primary/80 text-white p-6 text-center">
        <h2 className="text-2xl font-semibold mb-1">
          {slides[current].title}
        </h2>
        <p className="text-sm opacity-90">
          {slides[current].description}
        </p>
      </div>

      {/* Slide Dots */}
      <div className="absolute bottom-2 left-0 right-0 flex justify-center gap-2">
        {slides.map((_, index) => (
          <button
            key={index}
            onClick={() => setCurrent(index)}
            className={`w-3 h-3 rounded-full ${
              current === index ? "bg-white" : "bg-gray-400"
            }`}
          />
        ))}
      </div>

      {/* Prev / Next Controls */}
      <button
        onClick={() => setCurrent((prev) => (prev - 1 + slides.length) % slides.length)}
        className="absolute left-4 top-1/2 -translate-y-1/2 text-white bg-primary p-2 rounded-lg text-3xl"
      >
        ❮
      </button>
      <button
        onClick={() => setCurrent((prev) => (prev + 1) % slides.length)}
        className="absolute right-4 top-1/2 -translate-y-1/2 text-white bg-primary p-2 rounded-lg text-3xl"
      >
        ❯
      </button>
    </div>
  );
};

export default Slideshow;
